const BorderRadii = {
  sm: ".25rem",
  md: ".75rem",
  lg: "1.75rem",
}

export default BorderRadii
